module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Grant PBE - Pomorski Broker Eksportowy")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Project PBE Grant - Pomorski Broker\n          Eksportowy\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n         Grant PBE (\"Pomorski Broker Eksportowy\") ma na celu promocję Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach do 31.10.2023 r. Udział w renomowanych międzynarodowych imprezach wystawienniczych przyczyni się do zmiany modelu biznesowego Bioseco SA, a w konsekwencji przełoży się na wzrost eksportu innowacyjnych systemów detekcji wizyjnej.\n                  "), _c('br'), _c('Br'), _vm._v("\nCelem zrealizowanego projektu była promocja firmy Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach w terminie do 31.10.2023 roku. Przedstawiciele spółki wzięli udział w 6 wydarzeniach wystawienniczych. Realizacja projektu pozwoliła na zaprezentowanie oferty produktowej Bioseco w ważnych z punktu widzenia ekspansji wydarzeniach. Przedstawiciele spółki zaprezentowali nie tylko marketingowe aspekty rozwiązania, ale także podjęli wysiłek eksperckiego potwierdzenia skuteczności oferowanych rozwiązań. Zrealizowane działania były zgodne z polityką internacjonalizacji Bioseco, poprzez efektywne połączenie działalności promocyjnej z elementem budowania pozycji eksperta branżowego, wspieranym przez udział przedstawicieli firmy w panelach dyskusyjnych i prezentacjach.\n                  "), _c('br'), _c('br'), _vm._v("\nProjekt Grant PBE (\"Pomorski Broker Eksportowy\") jest współfinansowany z Unii Europejskiej."), _c('br'), _vm._v("Numer umowy: UDG-PBE.07.2023/026\n                ")], 1)]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                  Kwota dofinansowania z UE:"), _c('br'), _vm._v("\n                  79 593.29 PLN; 49,20%\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n              Project PBE Grant („Pomorski Broker Eksportowy”) aims to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions until 31.10.2023. Participation in renowned international exhibition events will contribute to a change in the business model of Bioseco SA and, as a result, will translate into increased exports of innovative vision detection systems\n\n                  "), _c('br'), _c('br'), _vm._v("\nThe aim of the project was to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions by 31.10.2023. Delegates of the company participated in 6 exhibition events. The implementation of the project enabled the Bioseco’s portfolio to be presented at key wind industry events. Representatives of the company presented not only the marketing aspects of the solution, but also made an effort to expertly confirm the effectiveness of the BPS. The realized activities were in line with Bioseco's internationalization policy, by effectively combining promotional activities with the element of building the position of an industry expert, supported by the participation of company representatives in discussions and presentations.\n                  "), _c('br'), _c('br'), _c('br'), _vm._v("Project PBE Grant („Pomorski Broker Eksportowy”) is co-financed from the European Union.\n                  "), _c('br'), _vm._v("Agreement number: UDG-PBE.07.2023/026\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                  Amount of founding from UE:"), _c('br'), _vm._v("\n                  79 593.29 PLN; 49,20%\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd010b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PBE2.vue
// module id = 285
// module chunks = 0